import styled from 'styled-components'

const Loading = styled.div`
  border: none;
  padding: 0;
  margin: 0;
  flex: 1;
  width: 100%;

  & .seg_loading {
    display: flex;
    padding: 0;
    margin: 0;
    border: 0;
    width: 100%;
    height: 100%;
    box-shadow: none;
  }
`

export { Loading }
